<template>
  <div>
    <loading-view v-if="loading" />
    <h1 class="bd-title pageTitle" id="content">
      Quote
      <small v-if="quote_response">{{ quote_response.label }}</small>
    </h1>

    <div>
      <quote-read v-if="quote_response" v-bind:response="quote_response" />
    </div>
  </div>
</template>

<script>
const PortalApi = require("@brightoncromwell/portal-api");
const quotesApiInstance = new PortalApi.QuotesApi();
let defaultClient = PortalApi.ApiClient.instance;

import LoadingView from '@/components/common/LoadingView';
import QuoteRead from "@/components/quotes/Read";
import { datadogLogs } from '@datadog/browser-logs';
import { getInstance } from '../../auth';

export default {
  name: "quote",
  metaInfo: {
    title: "Quote"
  },
  components: {
    "quote-read": QuoteRead,
    "loading-view": LoadingView
 },
  data() {
    return {
      loading: false,
      quote_response: null
    };
  },
  methods: {
    getQuote: async function(id) {
      const token = await this.getToken();
      let BearerAuth = defaultClient.authentications['BearerAuth'];
      BearerAuth.accessToken = token;
      this.loading = true;
      quotesApiInstance.quotesIdGet(id, (error, data, response) => {
        this.loading = false;
        if (error) {
          console.error(error);
          if(error == "login_required"){
                  window.location.href = "/signin";
          }
          datadogLogs.logger.error('getQuote() failed', { quoteId: id,  error: error });
          this.$emit('onError', response)
        } else {
          this.quote_response = data;
          console.log(data);
          datadogLogs.logger.info('getQuote() succeeded', { quoteId: this.quote_response.id });
        }
      });
    },
    // $auth isn't loaded in by the time the page tries to get the token, so we need to do some extra steps in order to wait
    getToken: async function(){
      return new Promise((resolve, reject) => {
        const instance = getInstance();
        if(instance.loading == false){
          // Redirect if the user isn't authenticated
          if (!instance.isAuthenticated){
            window.location.href = "/signin";
          }
          resolve(instance.getTokenSilently());
        }
        else{
        instance.$watch("loading", loading => {
            if (loading == false && instance.isAuthenticated){
              instance.getTokenSilently().then(authToken => {resolve(authToken)}).catch(error => {
                if(error == "login_required"){
                  window.location.href = "/signin";
                }
                reject(error)});
            }
            // Redirect if the user isn't authenticated
            else if (!instance.isAuthenticated){
              window.location.href = "/signin";
            }
          });
        }
      });
    },
  },
  created() {
    let id = this.$route.params.id;
    this.getQuote(id);
  },
  mounted() {
    datadogLogs.logger.info('Quote review page displayed', {});
  }
};
</script>